<template>
    <div
        class="modal fixed"
        aria-labelledby="add-card-modal-title"
        role="dialog"
        aria-modal="true"
    >
        <div class="modal-overlay" aria-hidden="true"></div>
        <div class="inner" style="-webkit-transform: translate3d(0, 0, 0)">
            <a
                href="#"
                class="modal-close-btn text-orange"
                role="button"
                @click.prevent="$emit('close')"
            >
                <i class="fal fa-times"></i>
            </a>
            <div
                class="modal-body items-start p-8 border-t-4 border-solid border-t-orange"
            >
                <div class="text-center">
                    <i class="fal fa-exclamation-circle text-7xl mb-5"></i>
                    <h3 class="text-2xl font-bold mb-5">
                        You Have {{ unmatchCount }} Card{{
                            unmatchCount > 1 ? 's' : ''
                        }}
                        to Match.
                    </h3>
                    <p class="text-xl max-w-lg mx-auto mb-5">
                        We need your help identifying which
                        {{
                            unmatchCount > 1
                                ? 'cards these are'
                                : 'card this is'
                        }}
                        in order for you to get the most out of My10x.
                    </p>
                </div>
            </div>
            <div class="modal-footer justify-between bg-gray-100">
                <button
                    type="button"
                    @click="close()"
                    class="btn-base btn-dark"
                    id="hs-wallet-close-unmatched-modal"
                >
                    Close
                </button>
                <button
                    type="button"
                    class="btn-base btn-white"
                    @click="illDoLater()"
                    id="hs-wallet-close-acknowledge-unmatched-cards"
                >
                    I know, I'll do it later
                </button>
            </div>
        </div>
    </div>
</template>
<script>
import Loading from '@/components/loading.vue';

export default {
    props: {
        unmatchCount: {
            type: Number,
            default: 0,
        },
    },
    components: {
        Loading,
    },
    data: () => ({}),
    methods: {
        illDoLater() {
            this.$cookies.set(
                'matchaccounts',
                '1',
                '14d',
                '/',
                window.location.hostname,
                true
            );
            this.$emit('close');
        },
        close() {
            this.$emit('close');
        },
    },
    mounted() {},
};
</script>
